<div class="project-component">

  <h2 *ngIf="projects && !projects.length">No projects with matching items</h2>

  <p-table [value]="projectControlItems"
           *ngIf="projectControlItems && projects.length"
           #table
           [style]="{'font-size': '0.8em'}"
           [rows]="100"
           [paginator]="true"
           [pageLinks]="3"
           [rowsPerPageOptions]="[10, 20, 50, 100]"
           [reorderableColumns]="true"
           [columns]="cols"
           selectionMode="multiple"
           exportFilename="project"
           dataKey="controlItem.category"
  >

    <ng-template pTemplate="caption">
      <div class="ui-helper-clearfix" style="display: flex;">
        <div style="flex: 1 1 auto; text-align: left">
          <button type="button"
                  pButton
                  class="risksponge-button"
                  icon="pi pi-list"
                  iconPos="left"
                  label="Expand/Collapse all"
                  (click)="toggleItems()"></button>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr [ngStyle]="{'white-space': 'nowrap', 'font-weight': 'bold'}">
        <th colspan="3">
          <div *ngIf="projects">
            <mat-select (selectionChange)="sourceProjectChange($event)" [(ngModel)]="sourceId">
              <mat-select-trigger>
                <div style="font-weight: bold; text-align: center; font-size: 1.4em;">{{getName(sourceId)}}</div>
              </mat-select-trigger>
              <mat-option *ngFor="let source of projects" [value]="source.projectId">{{source.name}}</mat-option>
            </mat-select>
          </div>
        </th>
        <th></th>
        <th colspan="3" style="font-weight: bold; text-align: center; font-size: 1.4em;">{{projectName}}</th>
      </tr>
      <tr>
        <th *ngFor="let col of cols" [pSortableColumn]="col.field" [ngStyle]="{'width': col.width || 'auto'}"
            style="font-weight: bold; text-align: center;">
          {{col.header}}
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item let-rowIndex="rowIndex" let-expanded="expanded" let-columns="columns">
      <tr class="ui-widget-header"
          *ngIf="rowGroupMetadata && rowGroupMetadata[item.controlItem.category].index === rowIndex">
        <td colspan="7">
          <a href="#" [pRowToggler]="item">
            <i [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
            <span>{{item['controlItem'].complianceArea.name}} - {{item['controlItem'].category}}</span>
          </a>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="expandedrow" let-rowIndex="rowIndex" let-item>
      <tr *ngIf="!item.hasParent">
        <td>
          <span href="#" *ngIf="item.subItems?.length"
                (click)="subVisible[item.projectControlItemId] = !subVisible[item.projectControlItemId]">
            <i
              [ngClass]="subVisible[item.projectControlItemId] ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
          </span>
          {{item.controlItem.complianceAreaControlId}}
        </td>
        <td>{{item.controlItem.category}}</td>
        <td>
          <ng-container
            *ngIf="item.controlItem.complianceArea.isExtended">{{item.controlItem?.shortName}}</ng-container>
        </td>
        <td>
          <mat-checkbox [(ngModel)]="item.isCopied"></mat-checkbox>
        </td>
        <td>
          <span href="#" *ngIf="item.subItems?.length"
                (click)="subVisible[item.projectControlItemId] = !subVisible[item.projectControlItemId]">
            <i
              [ngClass]="subVisible[item.projectControlItemId] ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
          </span>
          {{item.controlItem.complianceAreaControlId}}
        </td>
        <td>{{item.controlItem.category}}</td>
        <td>
          <ng-container
            *ngIf="item.controlItem.complianceArea.isExtended">{{item.controlItem?.shortName}}</ng-container>
        </td>
      </tr>


      <ng-container *ngIf="subVisible[item.projectControlItemId] && item.complianceArea.hasLevels">
        <ng-container *ngFor="let subItemLevel of item.subItemLevels">
          <tr>
            <td colspan="7" style="padding-left: 20px;">
            <span href="#" *ngIf="item.subItems?.length"
                  (click)="subVisible[item.projectConjtrolItem + '_' + subItemLevel.level] = !subVisible[item.projectConjtrolItem + '_' + subItemLevel.level]">
              <i
                [ngClass]="subVisible[item.projectConjtrolItem + '_' + subItemLevel.level] ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
            </span>
              {{subItemLevel.level}}</td>
          </tr>
          <ng-container *ngIf="subVisible[item.projectConjtrolItem + '_' + subItemLevel.level]">
            <tr *ngFor="let subIitem of subItemLevel.subItems">
              <td style="padding-left: 34px;">{{subIitem.controlItem.complianceAreaControlId}}
              </td>
              <td>{{subIitem.controlItem.category}}</td>
              <td>
                <mat-checkbox [(ngModel)]="item.isCopied"></mat-checkbox>
              </td>
            </tr>
          </ng-container>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="subVisible[item.projectControlItemId] && !item.complianceArea.hasLevels">
        <tr *ngFor="let subIitem of item.subItems">
          <td style="padding-left: 34px;">{{subIitem.controlItem.complianceAreaControlId}}
          </td>
          <td>{{subIitem.controlItem.category}}</td>
          <td>
            <mat-checkbox [(ngModel)]="item.isCopied"></mat-checkbox>
          </td>
        </tr>
      </ng-container>
    </ng-template>
  </p-table>
</div>
<button mat-raised-button (click)="onSave()" style="border-radius: 6px;" *ngIf="projects && projects.length">Save
</button>
